/**
 * Moduł obsługujący sekcję "Opis i dane" na karcie produktu,
 * zmienia widok, pomiędzy krotkim, a pełynm opisem
 */

app.service('productTabDescription',function(productMenu, modal, log, front, productCardConfig, productDescriptionGrade) {
	var $self;
	var $expandDescriptionBtn;
	var $descriptionContent;
	var $expandTableDetails;
	var $warrantiesScrollButton;
    var config;

	function setElements(){
		$self=$('#description');
		$descriptionContent=$('#description-content', $self);
		$expandDescriptionBtn=$('#expand-description', $self);
		$expandTableDetails=$('#toogle-tech-details', $self);
		$warrantiesScrollButton=$('.js-warranty-scroll', $self);
	}
	function setEvents(){
		$expandDescriptionBtn.click(function(){
			toggleDescription();
			productDescriptionGrade.init();
		});
		$expandTableDetails.click(function(){
			toggleTable();
		});
		$warrantiesScrollButton.on('click', function(){
			$.scrollTo($('#warranties').closest('.product-tab-gwarancje'),200);
		});
		$('.js-tech-details td:first-child a', $self).click(function () {
			UA.interaction('KP - Opis', 'Słownik', 'Cecha - '+$.trim($(this).text())+' - '+config.groupName);
		});
		$('.js-tech-details td:last-child a', $self).click(function () {
			UA.interaction('KP - Opis', 'Słownik', 'Wartość - '+$.trim($(this).text())+' - '+config.groupName);
		});
		$('#find-similar-products').click(function(){
			UA.pageInteraction('Opis', 'Znajdź podobne produkty');
		});
		var height=0;
		$('#description-content > *').each(function(){
			height+=$(this).height();
		});
		if($self.hasClass('full-desc')){
			productDescriptionGrade.init();
		}else if(height > $descriptionContent.height() && $descriptionContent.data('min')){
			$self.addClass('small-desc');
			$descriptionContent.css('max-height',$descriptionContent.data('min'));
		}
	}
	function toggleTable() {
		$self.toggleClass('full-tech');
		productMenu.scroll('description-tech-content');
	}
	function toggleDescription() {
		var full=$self.hasClass('full-desc')
		if(full){
			productMenu.scroll('opis');
		}
		$self.toggleClass('full-desc small-desc');
		UA.pageInteraction("Opis", full?"Rozwiń opis":"Zwiń opis");
		log.event({
			"id": "visitorInteraction",
			"f03": document.location.pathname,
			"f04": front.page(),
			"f05": "Opis i dane",
			"f06": full?"Rozwiń opis":"Zwiń opis",
			"f07": ""
		});
	}
	function init(){
		config = productCardConfig.getData();
		setElements();
		setEvents();
	}
	return {
		init
	};
});
